import axios from 'axios';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_URLBASE,
});

export const fetchTableData = async ({
                                         page = 1,
                                         pageSize = 12,
                                         casino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID'), 
                                         fechaInicio = '2025-01-26',
                                         fechaFin = '2025-01-30'
                                     }) => {
    try {
        const queryParams = new URLSearchParams({
            page: page.toString(),
            pageSize: pageSize.toString(),
            casino,
            fechaInicio,
            fechaFin,
        
        });

        const response = await apiClient.get(`/reportes/compratickets?${queryParams.toString()}`);

        if (response.status !== 200) {
            throw new Error('Error fetching data');
        }

        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

/*
 insert comments here
 */

export const fetchConsolidatedTableData = async ({
                                                     page = 1,
                                                     pageSize = 12,
                                                     casino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID'), 
                                                     period = "012025",
                                                     user = ""
                                                 }) => {
    try {
        const queryParams = new URLSearchParams({
            page: page.toString(),
            pageSize: pageSize.toString(),
            casino: casino,
            periodo: period,
            usuario: user
        });

        const response = await apiClient.get(`/reportes/planillasconsolidadas?${queryParams.toString()}`);
        console.log('url from fetchConsolidatedData:', response.config.url);

        if (response.status !== 200) {
            throw new Error('Error fetching data');
        }

        return response.data;
    } catch (error) {
        console.log(error);
        return [];
    }
};


export const fetchUsers = async () => {
    try {
        const response = await apiClient.get(`/user/get`);

        if (response.status !== 200) {
            throw new Error('Error fetching data');
        }
        return response.data.usuarios.map(user => user.mail);

    } catch (error) {
        console.log(error);
        return [];
    }
};

